import React from 'react';
import { NavLink } from 'react-router-dom';

const isRoot = (match, location) => {
  if (location.pathname === '/tour' ||
    location.pathname === '/tour/how-does-my-course-work') {
    return true;
  }
  return false;
};

const TourNav = () => (
  <nav className='switch-nav'>
    <NavLink to='/tour/how-does-my-course-work' activeClassName='is-active' isActive={isRoot}>
      <strong className='switch-nav__title'>
        <span className='long'>How does my course work?</span>
        <span className='short'>Course</span>
      </strong>
    </NavLink>
    <NavLink to='/tour/how-do-i-sign-up' activeClassName='is-active'>
      <strong className='switch-nav__title'>
        <span className='long'>Great! How do I sign up?</span>
        <span className='short'>Signup</span>
      </strong>
    </NavLink>
    <NavLink to='/tour/assessment-and-evidences' activeClassName='is-active'>
      <strong className='switch-nav__title'>
        <span className='long'>Assessment & NVQ evidences</span>
        <span className='short'>Assessment</span>
      </strong>
    </NavLink>
    <NavLink to='/tour/what-do-i-need' activeClassName='is-active'>
      <strong className='switch-nav__title'>
        <span className='long'>What do I need?</span>
        <span className='short'>Requirements</span>
      </strong>
    </NavLink>
  </nav>
);

export default TourNav;



// WEBPACK FOOTER //
// ./src/components/TourNav/index.js